"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNoResultsContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledNoResultsContainer = styled_components_1.default.div `
  padding: 2rem;
  background: ${ui_components_1.baseColors.white};

  display: flex;
  flex-direction: column;
  align-items: center;
`;
exports.default = exports.StyledNoResultsContainer;
